import React, { useContext, useEffect, useState } from "react";

// Context //
import GlobalContext from "../../../contexts/globalContext";
import defaultPicture from '../../../assets/images/profile/Avatar_circle_man.svg';

// Styles //
import "./FormDragAndDropInput.scss";

const FormDragAndDropInput = (props: any) => {
    const [message, setMessage] = useState<string>('Imagen inferior a 2MB y formato JPG')
    const [profilePhoto, setProfilePhoto] = useState(defaultPicture)
    const [dragActive, setDragActive] = React.useState(false);
    const Context = useContext(GlobalContext);
    const inputRef = React.useRef(null);

    // handle drag events
    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    // Set the file in form inputvalue and get a preview before upload it.
    const handleFile = (file: any) => {
        if (!file) return;

        if (file.size > 2000000) {
            setMessage('Tu foto excedio el peso. Intenta de nuevo.');
            return;
        }

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
            setMessage("Solo se permiten imágenes JPEG o PNG. Intenta de nuevo.");
            return;
        }

        // Restore the original message
        setMessage('Imagen inferior a 2MB y formato JPG')

        // Get a picture preview
        const reader = new FileReader();
        reader.onloadend = () => {
            setProfilePhoto(reader.result);
        };
        reader.readAsDataURL(file);

        //Upload to form input value
        props.setInputValue(props.nombreId, file, props.type);
    }

    // triggers when file is dropped
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            handleFile(e.dataTransfer.files[0]);
        }
    };

    // triggers when file is selected with click
    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.files && e.target.files[0]) {
            handleFile(e.target.files[0]);
        }
    };

    // triggers the input when the button is clicked
    const onButtonClick = () => {
        inputRef.current.click();
    };


    // Set image profile from gigya
    useEffect(() => {
        if (Context?.gigyaContext?.gigyaAccount?.profile.photoURL)
            setProfilePhoto(Context.gigyaContext.gigyaAccount.profile.photoURL);
    }, [Context.gigyaContext.gigyaAccount])


    return (
        <form
            id="form-file-upload"
            onDragEnter={handleDrag}
            onSubmit={(e) => e.preventDefault()}
        >
            <input
                ref={inputRef}
                type="file"
                id="input-file-upload"
                multiple={true}
                accept=".jpg,.jpeg,.png"
                onChange={handleChange}
            />
            <label
                id="label-file-upload"
                htmlFor="input-file-upload"
                className={dragActive ? "drag-active" : ""}
            >
                <div className="profile-picture">
                    <img src={profilePhoto} alt="Imagen de perfil de usuario" />
                </div>
                <div className="text-description">
                    <p>Arrasta o selecciona tu foto aquí</p>
                    <button className={`upload-button ${message.includes('Intenta') ? 'upload-button-error' : ''}`} onClick={onButtonClick}>
                        {message}
                    </button>
                </div>
            </label>
            {
                dragActive && (
                    <div
                        id="drag-file-element"
                        onDragEnter={handleDrag}
                        onDragLeave={handleDrag}
                        onDragOver={handleDrag}
                        onDrop={handleDrop}
                    ></div>
                )
            }
        </form >
    );
};

export default FormDragAndDropInput;
